module.exports = __webpack_public_path__ + "img/white-activate.9dbdcf1e.svg";